import * as React from 'react';
import classnames from 'classnames';

const DetailHeaderItem = ({ term , definition , className  })=>/*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("dt", {
        className: classnames('detail-header__term', className)
    }, term), /*#__PURE__*/ React.createElement("dd", {
        className: classnames('detail-header__definition', className)
    }, definition))
;
const DetailHeader = ({ className , children  })=>{
    const childArray = React.Children.toArray(children);
    const kids = childArray.map((child)=>/*#__PURE__*/ React.isValidElement(child) ? /*#__PURE__*/ React.cloneElement(child, {
            className: `columns-${childArray.length}`
        }) : child
    );
    return /*#__PURE__*/ React.createElement("dl", {
        className: classnames('detail-header', className)
    }, kids);
};
DetailHeader.Item = DetailHeaderItem;

export { DetailHeader as default };
//# sourceMappingURL=DetailHeader.js.map
